import { useFieldBase } from './useField';
export function useCheckbox({ atom, validationSelector, fieldName, disabled = false, disabledSelector, validationEffects = [], i18nVariables, required, defaultValue, i18nPrefix, }) {
    // get base props of validation fields
    const [{ value, ...baseProps }, saveValue] = useFieldBase({
        atom,
        fieldName,
        disabled,
        disabledSelector,
        validationSelector,
        validationEffects,
        i18nVariables,
        required,
        defaultValue,
        i18nPrefix,
    });
    return {
        onChange: (event) => saveValue(event.target.checked),
        checked: value ?? false, // null to undefined as MUI requires this to be undefined
        ...baseProps,
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationCheckbox = useCheckbox;
